import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { AppointmentStepperService } from '../../services/appointment-stepper.service';
import { ConfigService } from '../../services/env-config.service';
import { KeycloakService } from 'keycloak-angular';
import { ApiDebugService } from '../../services/api-debug.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  disabledMFA?: boolean;
  constructor(
    private storageService: StorageService,
    private router: Router,
    private dataService: DataService,
    private appointmentStepperService: AppointmentStepperService,
    //private apiDebug: ApiDebugService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request: HttpRequest<any> = req;
    const companyId = this.dataService.getCompanyId();
    if (companyId) {
      request = request.clone({ setHeaders: { 'X-Company-Id': companyId } });
    }
    const token: string | null = JSON.parse(this.storageService.getItem('authToken') || 'null');
    if (token) {    
      if (!request.url.includes('GetCalendarSchedulesByDossierCode') 
        && !request.url.includes('GetCalendarSchedulesByParams') ) { // inserito su richiesta di Mosè 18/07/25 per segnalazione security
        request = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
      }
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {

          //DEBUG ERROR
          /*this.apiDebug.addError({
            url: request.url,
            status: error.status,
            message: error.message,
            error: error.error
          });*/

          if (error.status === 401) {
            console.error('Authentication error, token may have expired');
            this.storageService.removeItem('authToken');
            this.storageService.removeItem('userData');
            this.storageService.removeItem('bodyAppointment');
            this.storageService.removeItem('bodyUserLog');
            this.storageService.removeItem('bodyApiNotification');
            this.appointmentStepperService.clearUsers();
            this.dataService.resetData();
            this.router.navigate(['login']);
          }
          return throwError(() => error);
        })
      );
    }
    return next.handle(request);
  }
}
